<template>
<div>
<Apptab />
<v-container>
    <h1>Dina möten</h1>
  <v-data-table
    :headers="headers"
    :items="schedule"
    :items-per-page="10"
    class="elevation-1"
  >
    <template v-slot:item.title="{ item }">
      <router-link :to="'/schedule/'+item.schedule_link">{{ item.title }}</router-link>
    </template>
  <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>{{ item.status === 'yes'?'öppna':'stängd' }}</v-chip>
    </template>
    <template v-slot:item.reply_deadline_date="{ item }">
      {{ item.reply_deadline === 'yes'?toDDMMYY(item.reply_deadline_date):'Ingen tidsfrist' }}
    </template>
    <template v-slot:item.id="{ item }">
      <v-btn :to="'/account/participants/'+item.id" v-show="item.participant_count > 0"><v-icon  
                    >fas fa-external-link-alt</v-icon></v-btn>
    </template>
  </v-data-table>
  </v-container>
  </div>
</template>


<script>
import Apptab from "./apptab";
import store from "../../../store";
import axios from "axios";
  export default {
  components: {
    Apptab,
  },
    data () {
      return {
        store: store,
        headers: [
          {
            text: 'Titel',
            align: 'start',
            sortable: false,
            value: 'title',
          },
          { text: 'Total röstning', value: 'participant_count' },
          { text: 'Status', value: 'status' },
          { text: 'Deadline', value: 'reply_deadline_date' },
          { text: 'Participants', value: 'id' },
        ],
        schedule: [],
      }
    },
    created: async function() {
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}outgoingschedules/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data.schedule;
    },
    methods: {
      getColor (status) {
        if (status === 'yes') return 'green'
        else return 'red'
      },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        }
    },
  }
</script>